import _ from 'lodash'
import React from 'react'
import { Button, Image, Modal, Segment } from 'semantic-ui-react'

import defaultAvatar from '../../assets/images/default-avatar.png'
import { tr } from '../../helpers/languages'

const Warning = (props) => {
    const days = [
        tr('MONDAYS'),
        tr('TUESDAYS'),
        tr('WEDNESDAYS'),
        tr('THURSDAYS'),
        tr('FRIDAYS'),
        tr('SATURDAYS'),
        tr('SUNDAYS')
    ]
    return (
        <Modal className='warning' open onClose={(_e) => { props.onClose() }}>
            <Modal.Content>
                <Segment className='warning-title'>
                    {tr('WARNING')}
                </Segment>
                <Segment className='warning-text'>
                    {tr('YOU_HAVE_SESSIONS')}&nbsp;
                    <span className='emphasised'>{tr('ALREADY_SCHEDULED')}</span>&nbsp;
                    {tr('IN_SOME_SLOTS_TO_BE_REMOVED')}
                </Segment>
                <Segment className='warning-question'>{tr('PROCEED_WITH_THE_CHANGES')}</Segment>
                <Segment className='warning-conflicts'>
                    {
                        /* eslint-disable react/no-array-index-key */
                        props.conflicts.map((conflict, index) => {
                            return (
                                <Segment.Group
                                    key={`conflict${index}`}
                                    horizontal
                                    className={`conflict ${index === props.conflicts.length - 1 ? 'last' : ''}`}
                                >
                                    <Segment className='conflict-image'>
                                        <Image
                                            src={_.isEmpty(conflict.client_img) ? defaultAvatar : conflict.client_img}
                                            circular/>
                                    </Segment>
                                    <Segment className='conflict-name'>
                                        {conflict.client_name}
                                    </Segment>
                                    <Segment className='conflict-session'>
                                        {days[conflict.weekday]}<br/>{conflict.start}&nbsp;-&nbsp;{conflict.end}
                                    </Segment>
                                    <Segment className='conflict-remaining'>
                                        {conflict.sessions_remaining}&nbsp;
                                        {tr(conflict.sessions_remaining === 1 ? 'MORE_WEEK' : 'MORE_WEEKS')}
                                    </Segment>
                                </Segment.Group>
                            )
                        })
                        /* eslint-enable react/no-array-index-key */
                    }
                </Segment>
                <Segment className='warning-note'>
                    {tr('AVAILABILITY_WILL_CHANGE_BUT')}&nbsp;
                    <span className='emphasised'>{tr('ABOVE_SESSIONS_REMAIN')}</span>
                </Segment>
                <Segment className='warning-buttons right aligned'>
                    <Button className='cancel-changes' onClick={(_e) => { props.onCancelChanges() }}>
                        {tr('CANCEL_CHANGES')}
                    </Button>
                    <Button className='save-changes' onClick={(_e) => { props.onSaveChanges() }}>
                        {tr('SAVE_CHANGES')}
                    </Button>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Warning



// WEBPACK FOOTER //
// ./src/components/availability/warning.js